import { FETCH_KPIS } from '../actions/kpis'

const initialState = {
    kpis: undefined,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_KPIS:
            return {
                ...state,
                kpis: action.payload,
            }
        default:
            return state
    }
}
